import { Icon } from '@toggle/design-system';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

import styles from './ChatMessagePrompt.module.scss';

export interface ChatMessagePromptProps {
  title: ReactNode;
  message: ReactNode;
  onClick?: () => void;
}

export const ChatMessagePrompt = ({
  title,
  message,
  onClick,
  ...rest
}: ChatMessagePromptProps) => {
  const Tag: React.ElementType = onClick ? 'button' : 'div';

  return (
    <Tag
      className={clsx(styles.container, {
        [styles.isButton]: !!onClick,
      })}
      onClick={onClick}
      data-testid="chat-message-prompt"
      {...rest}
    >
      <div className={styles.messageContainer}>
        <p className={styles.title}>{title}</p>
        <div className={styles.message}>{message}</div>
      </div>
      <div className={styles.iconContainer}>
        <Icon size={12} iconName="ArrowUp" />
      </div>
    </Tag>
  );
};
